import React, { Component } from "react";
import { Redirect } from 'react-router';
import PropTypes from "prop-types";
import Iframe from 'react-iframe';
import Version from "version";
import { base64toBlob, Transition } from "extras";

import withStyles from "@material-ui/core/styles/withStyles";
import AppBar from '@material-ui/core/AppBar';
import Slide from '@material-ui/core/Slide';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import CircularProgress from '@material-ui/core/CircularProgress';
import Badge from '@material-ui/core/Badge';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Grid from '@material-ui/core/Grid';
import Button from "components/CustomButtons/Button";
import overviewPageStyle from "assets/jss/material-dashboard-pro-react/views/overviewPageStyle";
import Icon from "../components/Selfcare/Common/Icon";

//Overview components
import SubscriptionUsage from "../components/Selfcare/Overview/SubscriptionUsage";

import InvoiceAccordion from "components/Selfcare/Overview/InvoiceAccordion";
import PrepaidRefills from "components/Selfcare/Overview/PrepaidRefills";
import OverviewSubscription from "components/Selfcare/Overview/OverviewSubscription";
import OverviewOtherSubscriptions from "components/Selfcare/Overview/OverviewOtherSubscriptions";

import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import Drawer from '@material-ui/core/Drawer';
import SwipeableViews from 'react-swipeable-views';

import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListSubheader from '@material-ui/core/ListSubheader';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import MenuIcon from '@material-ui/icons/Menu';
import classNames from 'classnames';


import Hidden from '@material-ui/core/Hidden';
import withWidth, { isWidthUp, isWidthDown } from '@material-ui/core/withWidth';
import compose from 'recompose/compose';
import Modal from '@material-ui/core/Modal';
import ReactLoading from 'react-loading';
import LinearProgress from '@material-ui/core/LinearProgress';
import { withSnackbar } from 'notistack';

import { withTranslation } from 'react-i18next';

// dotNetify
import dotnetify from 'dotnetify';

//Images
import Logo from "assets/img/Logo.png";

//Authorization
import auth from "../auth";
import ReactGA from 'react-ga';

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

import NotificationSystem from 'react-notification-system';
import viaplayLogo from '../assets/img/viaplay.png';
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';

var reactPlugin = new ReactPlugin();

const MySwal = withReactContent(Swal);
var width;

var administrating;

dotnetify.debug = true;

const TabContainer = ({ children, dir }) => {
    const padding = isWidthUp('md', width) ? "64px" : "56px"; 
    const height = isWidthUp('md', width) ? window.innerHeight - (64 + administrating) : window.innerHeight - (56 + administrating);
    return (
        <Typography component="div" dir={dir} style={{
            padding: 0, overflowY: 'auto', height: height.toString() + 'px', border: '1px solid blue' }}>
            {children}
        </Typography> 
    );
};

TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
    dir: PropTypes.string.isRequired,
};

var style = {
    NotificationItem: { // Override the notification item
        DefaultStyle: {
            fontSize: '13px',
        },
        info: {
            borderTop: '4px solid #c60055',
            backgroundColor: '#FCFCFC',
            color: '#ff4081',
            WebkitBoxShadow: '0 0 2px rgba( 116, 14, 79, 0.9 )',
            MozBoxShadow: '0 0 2px rgba( 116, 14, 79, 0.9 )',
            boxShadow: '0 0 2px rgba( 116, 14, 79, 0.9 )',
        }
    },
    Dismiss: {
        info: {
            color: '#e8f0f4',
            backgroundColor: '#c60055'
        }
    },
    Title: {
        info: {
            color: '#ff4081',
        },
    },
};

const stickToBottom = {
    width: '100%',
    position: 'fixed',
    bottom: 0,
    borderTop: '1px solid gray',
};

const styles = theme => ({
    ...overviewPageStyle,
    root: {
        color: "#555",
        fontSize: '0.6rem',
        padding: '0px',
        "&$selected": {
            color: "#e91e63",
            padding: '0px',
        },
    },
    selected: {
    },
    label: {
        fontSize: '0.6rem',
        "&$selected": {
            fontSize: "0.6rem",
        },
    },
    tabsRoot: {
        height: '64px',
    },
    tabRoot: {
        height: '64px',
    },
    tabsIndicator: {
        backgroundColor: '#FFF',
    },
    tabsLabelIcon: {
        minHeight: '0px',
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2),
        outline: 'none',
    },
});

//const InvoiceDialogContent = React.forwardRef((props, ref) => <div role="button" {...props} ref={ref} />);

function getModalStyle() {
    return {
        width: '300px',
        top: '50%',
        left: '50%',
        transform: `translate(-50%, -50%)`,
    };
}
export class Overview extends Component {
    constructor(props) {
        super(props);
        var currentUrl = window.location.href.split('?')[0]; 
        var paymentId = this.getParameterByName('paymentid') || '';
        if (paymentId) {
            window.history.replaceState(null, null, currentUrl);
        }
        this.vm = dotnetify.react.connect("Overview", this, {
            headers: {
                Authorization: "Bearer " + auth.getAccessToken(),
                ClientVersion: Version.getVersion(),
                ServerToken: window.sessionStorage.ServerToken
            },
            vmArg: {
                currentUrl,
                paymentId,
            },
            exceptionHandler: _ => auth.signOut()
        });
        // Set up function to dispatch state to the back-end.
        this.dispatchState = state => this.vm.$dispatch(state);
        // we use this to make the card to appear after the page has been rendered
        this.state = {
            anchorEl: null,
            InvoiceDialogOpen: false,
            PinPukDialogOpen: false,
            AboutDialogOpen: false,
            BetaDialogOpen: false,
            PaymentDialogOpen: false,
            LoadingSubscription: true,
            error: null,
            show: true,
            navigationValue: Number(window.sessionStorage.OverviewIndex),
            OptIn: false,
            OptInButtonDisabled: false,
            ShowSumoOffer: false,
            SumoOfferButtonDisabled: false,
            PdfBuzy: false,
            DrawerOpen: false,
            StateName: '',
        };
        this._notificationSystem = null;
        this.swipeableViews = null;
    }
    UNSAFE_componentWillMount() {
    }
    componentWillUnmount() {
        this.vm.$destroy();
    }
    componentDidMount() {
        window.onorientationchange = this.handleOrientationChange;
        this._notificationSystem = this.refs.notificationSystem;
        if (sessionStorage.stopAdmin) {
            var msisdn = sessionStorage.stopAdmin;
            sessionStorage.removeItem('stopAdmin');
            setTimeout(
                function () {
                    this.administrateNumber(msisdn);
                }.bind(this),
                50
            );
        }

    }
    UNSAFE_componentWillUpdate(nextProps, nextState) {
        if (nextState.Customer) {
            setTimeout(
                function () {
                    this.UpdateSwipeableViewHeight();
                }.bind(this),
                10
            );
        }
        if (nextState.StateName && !this.state.StateName) {
            setTimeout(
                function () {
                    this.setState({ [nextState.StateName]: nextState.StateValue });
                }.bind(this),
                5
            );
        }
        if (nextState.OpenUrl && !this.state.OpenUrl) {
            setTimeout(
                function () {
                    let a = document.createElement('a');
                    a.href = nextState.OpenUrl;
                    a.target = "_blank";
                    a.click();
                    this.setState({ ViaplayBuzy: false });
                }.bind(this),
                10
            );
        }
        if (nextState.SelfcareDisabled && !this.state.SelfcareDisabled) {
            auth.signOut();
        }
        if (nextState.GoDibs && !this.state.GoDibs) {
            window.location.replace(nextState.GoDibs);
            return;
        }
        if (nextState.Message && !this.state.Message) {
            setTimeout(
                function () {
                    MySwal.fire({
                        title: nextState.Message.MessageTitle,
                        html: nextState.Message.MessageText,
                        icon: nextState.Message.MessageType,
                        confirmButtonText: nextState.Message.ConfirmButtonText,
                        confirmButtonColor: '#e91e63',
                    }).then((result) => {
                        if (nextState.Message.OpenUrl) {
                            let a = document.createElement('a');
                            a.target = "_blank";
                            a.href = nextState.Message.OpenUrl;
                            a.click();
                        }
                        if (nextState.Message.RedirectToUrl) {
                            this.setState({ redirect: true, toUrl: nextState.Message.RedirectToUrl });
                        }
                    });
                }.bind(this),
                10
            );

        }
        if (nextState.Notification && !this.state.Notification) {
            this.showNotification(nextState.Notification);
        }

        if (nextState.InvoicePdfData && nextState.pdfAction === 'download') {
            var blob = base64toBlob(nextState.InvoicePdfData.Data, nextState.InvoicePdfData.DocumentType, 1024);
            this.downloadBlob(blob, nextState.InvoicePdfData.Filename);
        }
        if (nextState.InvoiceSpecPdfData && nextState.pdfAction === 'download') {
            var blobSpec = base64toBlob(nextState.InvoiceSpecPdfData.Data, nextState.InvoiceSpecPdfData.DocumentType, 1024);
            this.downloadBlob(blobSpec, nextState.InvoiceSpecPdfData.Filename);
        }
        if (this.state.LoadingSubscription === true && nextState.LoadingSubscription === false) {
            setTimeout(
                function () {
                    this.setState({ show: true });
                }.bind(this),
                10
            );
        }
        if (nextState.OrderConfirmed && !this.state.OrderConfirmed) {
            MySwal.fire({
                title: this.props.t('selfcare:notification.ordersent'),
                html: nextState.OrderConfirmationText,
                icon: 'success',
                confirmButtonColor: '#e91e63',
            });
        }
        if (nextState.OrderError && !this.state.OrderError) {
            MySwal.fire({
                title: 'Bestilling feilet',
                html: nextState.OrderError,
                icon: 'error',
                confirmButtonColor: '#e91e63',
            }).then((result) => {
                this.setState({ buzy: false });
            });
        }

        if (nextState.AdministrationChanged && !this.state.AdministrationChanged) {
            if (nextState.AdministratedMsisdn === '') {
                MySwal.fire({
                    title: this.props.t('selfcare:notification.administratingownnumber'),
                    html: this.props.t('selfcare:notification.anychangeswillbemadeinyournumber'),
                    icon: 'info',
                    confirmButtonColor: '#e91e63',
                });
                setTimeout(
                    function () {
                        this.dispatchState({ AdministrationChanged: false });
                        this.setState({ AdministrationChanged: false });
                    }.bind(this),
                    10
                );
            } else {
                MySwal.fire({
                    title: this.props.t('selfcare:notification.administrating', { 0: nextState.AdministratedMsisdn }),
                    html: this.props.t('selfcare:notification.nowadministrating', { 0: nextState.AdministratedMsisdn }),
                    icon: 'info',
                    confirmButtonColor: '#e91e63',
                });
                setTimeout(
                    function () {
                        this.dispatchState({ AdministrationChanged: false });
                        this.setState({ AdministrationChanged: false });
                    }.bind(this),
                    10
                );
            }
        }
        if (nextState.SuccessMessage && !this.state.SuccessMessage) {
            this.props.enqueueSnackbar(nextState.SuccessMessage, { variant: 'success' });
            setTimeout(
                function () {
                    this.dispatchState({ SuccessMessage: null });
                    this.setState({ SuccessMessage: null });
                }.bind(this),
                10
            );

        }
    }   
    isolateTouch(e) {
        e.stopPropagation();
    }
    componentDidUpdate() {
        this.swipeableActions.updateHeight();
    }
    handleOrientationChange = () => {
        setTimeout(
            function () {
                this.forceUpdate();
            }.bind(this),
            50
        );
    }
    hideAlert = () => {
        this.setState({
            alert: null
        });
    };
    handleChange = event => {
        this.setState({ value: event.target.value });
        this.setState({ error: null });
    };
    handleInvoiceDialogClose = () => {
        this.setState({ InvoiceDialogOpen: false, InvoicePdfCode: null, InvoicePdfData: null, pdfAction: null });
        this.dispatchState({ InvoicePdfCode: null, InvoicePdfData: null, InvoiceDialogOpen: false });
    };
    handlePinkPukDialogClose = () => {
        ReactGA.event({
            category: 'Navigation',
            action: 'View pin puk',
        });
        this.setState({ Pin: null, Puk: null, PinPukDialogOpen: false });
        this.dispatchState({ PinPukDialogOpen: false });
    };
    handleBetaDialogClose = () => {
        this.setState({ BetaDialogOpen: false, ChangeService: null, betaMessage: null, betaTitle: null });
    };
    handlePaymentDialogClose = () => {
        this.setState({ PaymentDialogOpen: false });
        this.dispatchState({ PaymentDialogOpen: false });
    };
    handleAboutDialogClose = () => {
        this.setState({ AboutDialogOpen: false });
    };
    handleClose = () => {
        this.setState({ anchorEl: null });
    };
    handleLogout = () => {
        this.setState({ anchorEl: null });
        auth.signOut();
    }
    handleProfile = () => {

    }
    handleHeight = () => {
        this.swipeableActions.updateHeight();
    }
    showBetaDialog = type => {
        if (type === 'changeUserInfo') {
            ReactGA.event({
                category: 'Navigation',
                action: 'Change user info'
            });

            const title = this.props.t('selfcare:info.changeuserinfo');
            this.setState({ BetaDialogOpen: true, betaTitle: title, betaMessage: this.props.t('selfcare:info.contacthelpchangeuserinfo') });
        }
        if (type === 'profile') {
            ReactGA.event({
                category: 'Navigation',
                action: 'Change address'
            });

            this.setState({ anchorEl: null, BetaDialogOpen: true, betaTitle: this.props.t('selfcare:info.changeaddress'), betaMessage: this.props.t('selfcare:info.contacthelpchangeaddress') });
        }
        if (type === 'blockSIM') {
            ReactGA.event({
                category: 'Navigation',
                action: 'Block simcard'
            });

            this.setState({ anchorEl: null, BetaDialogOpen: true, betaTitle: this.props.t('selfcare:info.blockunlock'), betaMessage: this.props.t('selfcare:info.contacthelpblockunlock') });
        }
        if (type === 'newSIM') {
            ReactGA.event({
                category: 'Navigation',
                action: 'Order simcard'
            });

            this.setState({ anchorEl: null, BetaDialogOpen: true, betaTitle: this.props.t('selfcare:info.ordersimcard'), betaMessage: this.props.t('selfcare:info.contacthelpordersimcard') });
        }
    }
    showInvoice = invoiceNo => e => {
        ReactGA.event({
            category: 'Navigation',
            action: 'Invoice viewed',
        });
        this.vm.$dispatch({
            GetInvoicePdf:
                { ReturnType: 'url', InvoiceNo: invoiceNo, Download: false }
        });
        this.setState({ pdfAction: 'viewUrl' });
    }
    downloadInvoice = invoiceNo => e => {
        ReactGA.event({
            category: 'Navigation',
            action: 'Invoice downloaded',
        });

        this.vm.$dispatch({
            GetInvoicePdf:
                { ReturnType: 'blob', InvoiceNo: invoiceNo, Download: true }
        });
        this.setState({ pdfAction: 'download' });
    }
    showInvoiceSpecification = invoiceNo => e => {
        ReactGA.event({
            category: 'Navigation',
            action: 'Invoice specification viewed',
        });
        this.vm.$dispatch({
            GetInvoiceSpecPdf:
                { ReturnType: 'url', InvoiceNo: invoiceNo, Download: false }
        });
        this.setState({ pdfAction: 'viewUrl' });
    }
    downloadInvoiceSpecification = invoiceNo => e => {
        ReactGA.event({
            category: 'Navigation',
            action: 'Invoice specification downloaded',
        });

        this.vm.$dispatch({
            GetInvoiceSpecPdf:
                { ReturnType: 'blob', InvoiceNo: invoiceNo, Download: true }
        });
        this.setState({ pdfAction: 'download' });
    }
    changeService = (ServiceNo, GroupId) => {
        ReactGA.event({
            category: 'Navigation',
            action: 'Service change'
        });
        window.sessionStorage.ServiceNo = ServiceNo;
        window.sessionStorage.GroupId = GroupId;
        this.navigateTo("/change-service");
    }
    administrateNumber = (msisdn) => {
        ReactGA.event({
            category: 'Navigation',
            action: 'AdministrateOtherNumber'
        });
        this.dispatchState({ 'Administrate': msisdn });
    }
    changeAdmin = (e, msisdn, value) => {
        this.dispatchState({ ChangeAdmin: { Msisdn: msisdn, Value: value } });
    }
    changeSetting = (e, setting) => {
        this.dispatchState({ ChangeSetting: { Setting: setting, Value: e.target.checked } });
    }
    downloadBlob(blob, filename) {
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style.display = "none";

        // IE
        if (window.navigator.msSaveOrOpenBlob) {
            a.onclick = ((evx) => {

                window.navigator.msSaveOrOpenBlob(blob, filename);
            });
            a.click();
        }
        else //Chrome and safari
        {
            var file = URL.createObjectURL(blob);
            a.href = file;
            a["download"] = filename;
            a.click();
            setTimeout(
                function () {
                    window.URL.revokeObjectURL(file);
                },
                2000
            );
        }
        this.clearPdfData();
    }
    getInvoiceUrl() {
        if (this.state.pdfAction === 'viewUrl') {
            var uri = window.location.protocol + '//' + window.location.host;
            return this.state.InvoicePdfCode ? 'https://mozilla.github.io/pdf.js/web/viewer.html?file=' + uri + `/api/document/pdf/${this.state.InvoicePdfCode}` : '';
        } else {
            if (this.state.InvoicePdfData && this.state.InvoicePdfData.Data) {
                var blob = base64toBlob(this.state.InvoicePdfData.Data, this.state.InvoicePdfData.DocumentType, 1024);
                var file = URL.createObjectURL(blob);
                return file;
            } else { return ''; }
        }
    }
    showNotification = notification => {
        setTimeout(
            function () {
                this._notificationSystem.addNotification({
                    title: notification.Title,
                    message: notification.Message,
                    level: 'info',
                    position: 'tc',
                });
            }.bind(this),
            notification.Delay
        );
        this.setState({ Notification: null });
        this.dispatchState({ Notification: null })
    }
    clearPdfData = () => {
        this.setState({ pdfAction: null });
        this.setState({ InvoicePdfCode: null, InvoicePdfData: null, InvoiceSpecPdfData: null });
        this.dispatchState({ InvoicePdfCode: null, InvoicePdfData: null, InvoiceSpecPdfData: null });
    }
    showPinPuk = () => {
        this.dispatchState({ GetPinPuk: this.state.ClientIp });
    }

    showPaymentDetails = () => {
        this.dispatchState({ GetPaymentDetails: true });
    }
    changeAddress = () => {
        this.navigateTo('/change-address');
        //this.showBetaDialog('profile');
    }
    navigateTo = url => {
        this.setState({ show: false });
        setTimeout(
            function () {
                this.setState({
                    toUrl: url,
                    redirect: true
                });
            }.bind(this),
            300
        );
    }
    handleNavigationChange = (event, value) => {
        if (value === 3) { //Menu on mobile device
            this.setState({ DrawerOpen: true });
            return;
        }
        this.handleChangeIndex(value);
    };
    handleChangeIndex = index => {
        window.sessionStorage.OverviewIndex = index;
        this.setState({ navigationValue: index });
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    };
    toggleDrawer = (open) => () => {
        this.setState({
            DrawerOpen: open
        });
    };
    getParameterByName(name) {
        var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
        return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
    };
    UpdateSwipeableViewHeight = () => {
        if (this.swipeableActions) this.swipeableActions.updateHeight();
    };


    render() {
        administrating = this.state.IsAdministrating ? 50 : 0;
        width = this.props.width;
        const padding = isWidthUp('md', width) ? "64px" : "56px";
        const height = isWidthUp('md', width) ? window.innerHeight - (64 + administrating) : window.innerHeight - (56 + administrating);
        const paddingBottom = isWidthUp('md', width) ? "0px" : administrating ? "106px" : "56px";
        const { classes } = this.props;
        const { t } = this.props;
        const { anchorEl, show } = this.state;
        const open = Boolean(anchorEl);
        const subscription = this.state.Subscription;
        const invoices = this.state.Customer && this.state.Customer.InvoiceList;
        const server = this.state.ServerName ? this.state.ServerName : 'loading...';
        const dialogUrl = this.state.InvoiceDialogOpen ? this.getInvoiceUrl() : '';
        var topPadding = "0px";
        if (isWidthUp('md', this.props.width)) {
            topPadding = "64px";
        }
        const sideList = (
            <div className={classes.list}>
                <List>
                    <ListSubheader>{t('selfcare:title.shortcuts')}</ListSubheader>

                    <ListItem button onClick={() => this.changeAddress()}>
                        <ListItemIcon><Icon name="id-card" size={24} color="#e91e60" /></ListItemIcon>
                        <ListItemText primary={t('selfcare:item.changeaddress')} />
                    </ListItem>
                    <ListItem button onClick={() => this.navigateTo('/change-password')}>
                        <ListItemIcon><Icon name="lock" size={24} color="#e91e60" /></ListItemIcon>
                        <ListItemText primary={t('selfcare:item.changepassword')} />
                    </ListItem>
                    {this.state.Subscription && this.state.Subscription.CanChangePriceplan &&
                        <ListItem button onClick={() => this.navigateTo('/change-subscription')} style={{
                            display: this.state.Subscription && this.state.Subscription.CanChangePriceplan ? 'flex' : 'none'
                        }} >
                        <ListItemIcon><Icon name="money" size={24} color="#e91e60" /></ListItemIcon>
                        <ListItemText primary={this.state.IsSweden ? t('selfcare:item.change-subscription-type-swe') : t('selfcare:phrase.change') + ` ${this.state.Subscription.Type}`} />
                        </ListItem>}
                    <ListItem button onClick={() => this.showPinPuk()}>
                        <ListItemIcon><Icon name="pin" size={24} color="#e91e60" /></ListItemIcon>
                        <ListItemText primary={t('selfcare:item.showpinpuk')} />
                    </ListItem>
                </List>
                <Divider />
                <List>
                    <ListItem button onClick={() => this.setState({ AboutDialogOpen: true })}>
                        <ListItemIcon><Icon name="information" size={24} color="#e91e60" /></ListItemIcon>
                        <ListItemText primary={t('selfcare:item.aboutminside')} />
                    </ListItem>
                    <ListItem button onClick={() => this.handleLogout()}>
                        <ListItemIcon><Icon name="logout" size={24} color="#e91e60" /></ListItemIcon>
                        <ListItemText primary={t('selfcare:item.signout')} />
                    </ListItem>
                </List>
            </div>
        );

        return (
            <div>
                {this.state.redirect ? <Redirect to={this.state.toUrl} /> : null}
                <NotificationSystem ref="notificationSystem" style={style} />
                <Modal
                    aria-labelledby={t('selfcare:label.loadpdf')}
                    aria-describedby={t('selfcare:label.downloadpdf')}
                    open={this.state.PdfBuzy}
                >
                    <div style={getModalStyle()} className={classes.paper}>
                        <Typography id="modal-title">
                            {this.state.PdfBuzyText}
                        </Typography>
                        <LinearProgress color="secondary" variant="query" />
                    </div>
                </Modal>
                {this.state.LoadingSubscription &&
                    <GridContainer justify="center" alignItems="center" direction="row" style={{ height: '100vh' }}>
                        <GridItem>
                            <ReactLoading type={"bubbles"} color={"#e91e63"} height={'50px'} width={'50px'} />
                        </GridItem>
                    </GridContainer>}
                <Hidden smDown>
                    <AppBar position="fixed" className={classes.AppBar} style={{ zIndex: 2000 }}>
                        <Toolbar>
                            <IconButton
                                color="inherit"
                                aria-label="Open drawer"
                                onClick={this.toggleDrawer(!this.state.DrawerOpen)}
                                className={classNames(classes.menuButton, open && classes.hide)}
                            >
                                <MenuIcon />
                            </IconButton>
                            <img src={Logo} width={80} alt="Chilimobil" />
                            <Typography variant="h6" color="inherit" className={classes.flex} style={{ paddingLeft: '10px' }}>
                                {t('selfcare:title.minside')}
                                </Typography>
                            <Tabs classes={{ indicator: classes.tabsIndicator, root: classes.tabsRoot }} value={this.state.navigationValue} onChange={this.handleNavigationChange}>
                                <Tab label={t('selfcare:tab.overview')} classes={{ root: classes.tabRoot, labelIcon: classes.tabsLabelIcon }} icon={<Icon name="usage" size={24} color="currentColor" />} />
                                <Tab label={this.state.IsSweden ? t('selfcare:label.my-subscription-swe') : t('selfcare:tab.subscription', { 0: `${this.state.Subscription ? this.state.Subscription.Type : t('selfcare:phrase.subscriptionlc')}` })} classes={{ root: classes.tabRoot, labelIcon: classes.tabsLabelIcon }} icon={<Icon name="settings" size={24} color="currentColor" />} />
                                <Tab label={`${this.state.Customer && this.state.Customer.TypeNo === "20" ? t('selfcare:tab.othersubscriptioncompany') : t('selfcare:tab.othersubscriptionfamily')}`} classes={{ root: classes.tabRoot, labelIcon: classes.tabsLabelIcon }} icon={<Icon name="family" size={24} color="currentColor" />} />
                            </Tabs>
                        </Toolbar>
                    </AppBar>
                </Hidden>

                <Dialog
                    fullScreen
                    open={this.state.InvoiceDialogOpen}
                    onClose={this.handleInvoiceDialogClose}
                    TransitionComponent={Transition}
                    style={{ zIndex: 3000 }}
                >
                    <AppBar className={classes.AppBar}>
                        <Toolbar>
                            <IconButton id='close' color="inherit" onClick={this.handleInvoiceDialogClose} aria-label="Close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" color="inherit" className={classes.flex}>
                                {this.state.InvoiceViewType}
                            </Typography>
                        </Toolbar>
                    </AppBar>
                    <Iframe url={dialogUrl}
                        width="100%"
                        height="100%"
                        id="invoicePdf"
                        display="initial"
                        position="relative"
                        />
                </Dialog>
                <Dialog
                    open={this.state.PinPukDialogOpen}
                    onClose={this.handlePinkPukDialogClose}
                    aria-labelledby="responsive-dialog-title"
                >
                    <DialogTitle id="responsive-dialog-title">{t('selfcare:title.pinpuk')}</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            <span dangerouslySetInnerHTML={{ __html: t('selfcare:dialog.pinpuksim', { statePin: this.state.Pin, statePuk: this.state.Puk, stateICC: this.state.ICC }) }} />
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handlePinkPukDialogClose} color="rose">
                            {t('selfcare:button.done')}
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={this.state.PaymentDialogOpen}
                    onClose={this.handlePaymentDialogClose}
                    aria-labelledby="responsive-dialog-title"
                >
                    <DialogTitle id="responsive-dialog-title">
                        <Icon name="credit-card" size={36} color="#e91e63" />
                        {this.state.PaymentDialogType === "change" &&
                            <span style={{ marginLeft: '20px' }}>{t('selfcare:title.change-payment')}</span>}
                        {this.state.PaymentDialogType === "pay" &&
                        <span style={{ marginLeft: '20px' }}>{t('selfcare:title.make-payment')}</span>}
                    </DialogTitle>
                    <DialogContent>
                            {this.state.Subscription && this.state.Subscription.PaymentInfo && <Grid container style={{ color: '#000', fontSize: '1rem' }}>
                                <Grid item xs={12} sm={6}>
                                    <div style={{ textTransform: 'uppercase' }}>
                                        {t('selfcare:label.card-number')}
                                    </div>
                                    <div>
                                        {this.state.Subscription.PaymentInfo.CardNo}
                                    </div>
                                    <div style={{ textTransform: 'uppercase', marginTop: '10px' }}>
                                        {t('selfcare:label.valid-to')}
                                    </div>
                                    <div>
                                        {this.state.Subscription.PaymentInfo.ValidTo}
                                    </div>
                                    <Icon name={this.state.Subscription.PaymentInfo.CardType} size={36} />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    {this.state.PaymentDialogType === "change" &&
                                        <span dangerouslySetInnerHTML={{ __html: t('selfcare:info.change-payment') }} />}
                                    {this.state.PaymentDialogType === "pay" &&
                                        <span dangerouslySetInnerHTML={{ __html: this.state.PaymentDialogText }} />}
                                </Grid>
                            </Grid>}
                    </DialogContent>
                    <DialogActions>
                        {this.state.PaymentDialogType === "change" &&
                            <Button onClick={() => this.dispatchState({ ChangePaymentDetails: true })} color="rose">
                                {t('selfcare:button.change')}
                            </Button>}
                        {this.state.PaymentDialogType === "pay" &&
                            <Button onClick={() => this.dispatchState({ ConfirmPayment: true })} color="rose">
                                {t('selfcare:button.accept')}
                            </Button>}
                        <Button onClick={this.handlePaymentDialogClose}>
                            {t('selfcare:button.cancel')}
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={this.state.AboutDialogOpen}
                    onClose={this.handleAboutDialogClose}
                    aria-labelledby="responsive-dialog-title"
                >
                    <DialogTitle id="responsive-dialog-title">{t('selfcare:title.aboutminside')}</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            <span dangerouslySetInnerHTML={{ __html: t('selfcare:dialog.aboutminside', { stateClientVersion: this.state.ClientVersion, stateServerVersion: this.state.ServerVersion, server: server, propsWidth: this.props.width }) }} />
                            <br /><br />
                            <span dangerouslySetInnerHTML={{ __html: t('selfcare:info.copyright-date', { 0: 1900 + new Date().getYear() }) }} />
                            </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleAboutDialogClose} color="rose">
                            {t('selfcare:button.ok')}
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={this.state.BetaDialogOpen}
                    onClose={this.handleBetaDialogClose}
                    aria-labelledby="responsive-dialog-title"
                >
                    <DialogTitle id="responsive-dialog-title">{this.state.betaTitle} </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            {t('selfcare:dialog.functionavailablesoon')}<br /><br />
                            <span dangerouslySetInnerHTML={{ __html: this.state.betaMessage }} />
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleBetaDialogClose} color="rose">
                            {t('selfcare:button.ok')}
                        </Button>
                    </DialogActions>
                </Dialog>
                <div>
                    <div style={{ height: topPadding }} />
                    {this.state.IsAdministrating && <div style={{ backgroundColor: 'black', color: 'white', height: '50px', paddingLeft: '5px', textAlign: 'center', borderBottom: '1px grey solid' }}>{t('selfcare:admin.administeringnumber')} {this.state.AdministratedMsisdn}<br /><a style={{ color: 'white' }} href='/overview' onClick={(e) => { this.administrateNumber(this.state.LoggedInMsisdn); e.preventDefault(); }}>{t('selfcare:admin.backtologgedinuser')}</a></div>}

                    <SwipeableViews
                        axis='x'
                        index={this.state.navigationValue}
                        onChangeIndex={index => {
                            this.handleChangeIndex(index);
                            this.UpdateSwipeableViewHeight();
                        }
                        }
                        action={actions => (this.swipeableActions = actions)}
                        animateHeight
                        containerStyle={{ WebkitOverflowScrolling: 'touch' }}
                        ref={(ref) => this.swipeableViews = ref}
                    >
                        <div>
                            {/*<Slide direction="down" in={show} mountOnEnter unmountOnExit>*/}
                                <div>
                                    <GridContainer justify="center" spacing={0}>
                                        <GridItem xs={12} style={{ backgroundColor: 'white' }}>
                                            <div>
                                                {this.state.Subscription && <SubscriptionUsage updateHeight={this.UpdateSwipeableViewHeight} subscription={this.state.Subscription} loadingSubscription={this.state.LoadingSubscription} classes={this.props.classes} navigateTo={this.navigateTo} />}
                                            </div>
                                        </GridItem>
                                    </GridContainer>
                                </div>
                            {/*</Slide>*/}
                            <GridContainer justify="center" spacing={0}>
                                <GridItem xs={12}>
                                    <GridContainer spacing={0} justify="center">
                                        <GridItem xs={12} lg={8} xl={6} style={{ maxWidth: '900px' }}>
                                            {/*<Slide direction="up" in={show} mountOnEnter unmountOnExit>*/}
                                                <div>
                                                    <GridContainer justify="space-between" spacing={0}>
                                                        <GridItem xs={12} md={6}>
                                                            {this.state.ShowViaplayOffer &&
                                                                <div style={{ margin: '20px 10px', borderRadius: '10px', border: '1px solid #555', textAlign: 'center', backgroundColor: '#FFF', boxShadow: '4px 9px 22px 0 rgba(0, 0, 0, 0.13)', WebkitBoxShadow: '4px 9px 22px 0 rgba(0, 0, 0, 0.13)', MozBoxShadow: '4px 9px 22px 0 rgba(0, 0, 0, 0.13)' }}>
                                                                <div style={{ padding: '10px', textAlign: 'center' }}>
                                                                    <p style={{ textAlign: 'left', fontSize: '0.875rem' }}><span dangerouslySetInnerHTML={{ __html: this.state.ViaplayText }} /></p>
                                                                    <img style={{ width: '100px', marginBottom: '10px' }} src={viaplayLogo} alt="Viaplay" />
                                                                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
                                                                        <Button style={{ borderRadius: '16px' }} id='register-viaplay' size="sm" color="rose" disabled={this.state.ViaplayBuzy} onClick={() => {
                                                                            this.dispatchState({ AcceptViaplayOffer: true }); this.setState({ ViaplayBuzy: true });
                                                                        }}
                                                                        >
                                                                            Aktivera Viaplay
                                                                        </Button>
                                                                        <Button style={{ borderRadius: '16px' }} variant="outlined" size="sm" disabled={this.state.ViaplayBuzy} onClick={() => {
                                                                            this.dispatchState({ AcceptViaplayOffer: false }); this.setState({ ViaplayBuzy: true });
                                                                        }}
                                                                        >
                                                                            Nej tack
                                                                            </Button>
                                                                    </div>
                                                                        {this.state.ViaplayBuzy &&
                                                                            <div style={{ display: 'flex', flexFlow: 'row nowrap', justifyContent: 'center', width: '100%' }}>
                                                                                <ReactLoading type={"bubbles"} color={"#e91e63"} height={'50px'} width={'50px'} />
                                                                            </div>}
                                                                    </div>
                                                                </div>}
                                                            {this.state.ShowActivateViaplay &&
                                                                <div style={{ margin: '20px 10px', borderRadius: '10px', border: '1px solid #555', textAlign: 'center', backgroundColor: '#FFF', boxShadow: '4px 9px 22px 0 rgba(0, 0, 0, 0.13)', WebkitBoxShadow: '4px 9px 22px 0 rgba(0, 0, 0, 0.13)', MozBoxShadow: '4px 9px 22px 0 rgba(0, 0, 0, 0.13)' }}>
                                                                    <div style={{ padding: '10px', textAlign: 'center' }}>
                                                                        <p style={{ textAlign: 'left', fontSize: '0.875rem' }}><span dangerouslySetInnerHTML={{ __html: this.state.ViaplayText }} /></p>
                                                                        <img style={{ width: '100px', marginBottom: '10px' }} src={viaplayLogo} alt="Viaplay" />
                                                                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
                                                                            <Button style={{ borderRadius: '16px' }} id='register-viaplay' size="sm" color="rose" disabled={this.state.ViaplayBuzy} onClick={() => {
                                                                                this.dispatchState({ ActivateViaplay: true }); this.setState({ ViaplayBuzy: true });
                                                                            }}
                                                                            >
                                                                            {t('selfcare:button.activate-viaplay')}
                                                                        </Button>
                                                                            <Button style={{ borderRadius: '16px' }} variant="outlined" size="sm" disabled={this.state.ViaplayBuzy} onClick={() => {
                                                                                this.dispatchState({ ActivateViaplay: false }); this.setState({ ViaplayBuzy: true });
                                                                            }}
                                                                            >
                                                                            {t('selfcare:button.cancelorder')}l
                                                                            </Button>
                                                                        </div>
                                                                        {this.state.ViaplayBuzy &&
                                                                            <div style={{ display: 'flex', flexFlow: 'row nowrap', justifyContent: 'center', width: '100%' }}>
                                                                                <ReactLoading type={"bubbles"} color={"#e91e63"} height={'50px'} width={'50px'} />
                                                                            </div>}
                                                                    </div>
                                                                </div>}
                                                            {this.state.ShowSumoOffer    &&
                                                                <div style={{ margin: '20px', borderRadius: '5px', border: '1px solid #555', textAlign: 'center', backgroundColor: '#FFF', boxShadow: '4px 9px 22px 0 rgba(0, 0, 0, 0.13)', WebkitBoxShadow: '4px 9px 22px 0 rgba(0, 0, 0, 0.13)', MozBoxShadow: '4px 9px 22px 0 rgba(0, 0, 0, 0.13)' }}>
                                                                    <Typography variant="h6" color="secondary" style={{ padding: '20px 20px 5px 20px' }}>
                                                                    {t('selfcare:title.tv-2-sumo')}
                                                        </Typography>
                                                                <div style={{ padding: '0px 20px 20px 20px', fontSize: '16px', textAlign: 'center' }}>
                                                                    <p style={{ textAlign: 'left' }}><span dangerouslySetInnerHTML={{ __html: t('selfcare:info.tv-2-sumo-christmas-gift') }} /></p>
                                                                        <Button id='sumo_opt_in' color="rose" style={{ marginTop: '10px' }} disabled={this.state.SumoOfferButtonDisabled} onClick={() => {
                                                                            this.dispatchState({ AcceptSumoOffer: true }); this.setState({ SumoOfferButtonDisabled: true });
                                                                        }}
                                                                        >
                                                                        {t('selfcare:button.yes-please')}
                                                                        </Button>
                                                                    {this.state.SumoOfferButtonDisabled &&
                                                                        <div style={{ display: 'flex', flexFlow: 'row nowrap', justifyContent: 'center', width: '100%' }}>
                                                                                <ReactLoading type={"bubbles"} color={"#e91e63"} height={'50px'} width={'50px'} />
                                                                            </div>}
                                                                    </div>
                                                                </div>}

                                                            {this.state.Customer && this.state.Customer.HasInvoices &&
                                                                <div style={{ width: '100%' }}>
                                                                    {this.state.IsSweden && this.state.PaymentInfoMessage &&
                                                                        <div style={{ color: 'red', padding: '10px', border: '1px solid gray', borderRadius: '10px', backgroundColor: '#FFF', margin: '10px 10px' }}>{this.state.PaymentInfoMessage}</div>
                                                                    }
                                                                    {this.state.IsSweden && this.state.PaymentMessage &&
                                                                        <div style={{ padding: '10px', border: '1px solid gray', borderRadius: '10px', backgroundColor: '#FFF', margin: '10px 10px' }}>
                                                                            <div>{this.state.PaymentMessage}</div>
                                                                    <div style={{ width: '100%', textAlign: 'center' }}><Button color="rose" style={{ marginTop: '10px', borderRadius: '19px' }} onClick={() => this.dispatchState({ SettleDebt: true })}>Betala {this.state.PaymentAmount}</Button></div>
                                                                        </div>
                                                                    }   
                                                                    <Typography variant="h6" color="secondary" style={{ padding: '10px', marginBottom: '10px' }}>
                                                                        {this.state.Customer.UnpaidInvoiceCount && this.state.Customer.UnpaidInvoiceCount > 0 ?
                                                                            <Badge badgeContent={this.state.Customer.UnpaidInvoiceCount} color="error">
                                                                            {t('selfcare:info.invoice')}
                                                                        </Badge> : t('selfcare:info.invoice')}
                                                                    </Typography>
                                                                    {this.state.Customer && this.state.Customer.HasInvoices && this.state.Customer.LoadingInvoices && <div style={{ padding: '10px', width: '100%' }}><ReactLoading type={"bubbles"} color={"#e91e63"} height={'50px'} width={'50px'} /></div>}
                                                                    {this.state.InvoiceMessage && !this.state.InvoiceError ? <div style={{ padding: '10px' }}>{this.state.InvoiceMessage}</div> : ''}
                                                                    {this.state.InvoiceMessage && this.state.InvoiceError ? <div style={{ padding: '10px', color: 'red' }}>{this.state.InvoiceMessage}</div> : ''}
                                                                    {invoices &&
                                                                    <InvoiceAccordion updateHeight={this.UpdateSwipeableViewHeight} IsSweden={this.state.IsSweden} invoices={invoices} color="rose" isAdministrating={this.state.IsAdministrating} showInvoice={this.showInvoice} downloadInvoice={this.downloadInvoice} showSpec={this.showInvoiceSpecification} downloadSpec={this.downloadInvoiceSpecification} classes={classes} />}
                                                                </div>}
                                                            {this.state.Subscription && this.state.Subscription.IsPrepaid &&
                                                                <div style={{ width: '100%' }}>
                                                                    <Typography variant="h6" color="secondary" style={{ padding: '10px', marginBottom: '-16px' }}>
                                                                    {t('selfcare:info.refillhistory')}
                                                                    </Typography>
                                                                    {this.state.Subscription && this.state.Subscription.IsPrepaid && this.state.Subscription.RefillsLoading && <div style={{ padding: '10px', width: '100%' }}><ReactLoading type={"bubbles"} color={"#e91e63"} height={'50px'} width={'50px'} /></div>}
                                                                    {this.state.Subscription && this.state.Subscription.IsPrepaid && this.state.Subscription.RefillText ? <div style={{ padding: '10px' }}>{this.state.Subscription.RefillText}</div> : ''}
                                                                    {this.state.Subscription && this.state.Subscription.IsPrepaid &&
                                                                    <PrepaidRefills updateHeight={this.UpdateSwipeableViewHeight} subscription={this.state.Subscription} classes={classes} />}
                                                                </div>}
                                                        </GridItem>
                                                        <GridItem xs={12} md={6}>
                                                            {this.state.OptIn &&
                                                                <div style={{ margin: '20px', borderRadius: '5px', border: '1px solid #555' }}>
                                                                    <Typography variant="h6" color="secondary" style={{ padding: '20px 20px 5px 20px' }}>
                                                                    {t('selfcare:title.tv2sumo')}
                                                        </Typography>
                                                                <div style={{ padding: '0px 20px 20px 20px', fontSize: '12px' }}>
                                                                    <span dangerouslySetInnerHTML={{ __html: t('selfcare:info.tv2sumo', { 0: this.state.SumoDate }) }} /><br />
                                                                        <Button id='sumo_opt_in' color="rose" style={{ marginTop: '10px' }} disabled={this.state.OptInButtonDisabled} onClick={() => {
                                                                            this.dispatchState({ AcceptSumo: true }); this.setState({ OptInButtonDisabled: true });
                                                                        }}
                                                                        >
                                                                        {t('selfcare:button.tv2sumo')}
                                                        </Button>
                                                                        {this.state.OptInButtonDisabled &&
                                                                            <div><br />
                                                                                <ReactLoading type={"bubbles"} color={"#e91e63"} height={'50px'} width={'50px'} />
                                                                            </div>}
                                                                    </div>
                                                                </div>}
                                                            {this.state.Subscription && (<div>
                                                                <Typography variant="h6" color="secondary" style={{ padding: '10px', marginBottom: '12px' }}>
                                                                    {t('selfcare:info.shortcuts')}
                                                                </Typography>
                                                                <List style={{ padding: '0px' }}>
                                                                    {this.state.Subscription.CanChangePriceplan &&
                                                                        <Divider variant="middle" component="li" />}
                                                                {this.state.Subscription.CanChangePriceplan &&
                                                                    <ListItem button onClick={() => { this.navigateTo('/change-subscription') }}>
                                                                            <ListItemText
                                                                            primary={
                                                                                this.state.IsSweden
                                                                                    ?
                                                                                    t('selfcare:item.change-subscription-type-swe')
                                                                                    :
                                                                                t('selfcare:item.changesubscription', { 0: `${this.state.Subscription ? this.state.Subscription.Type : t('selfcare:phrase.subscriptionlc')}` })
                                                                            }
                                                                            />
                                                                            <ListItemSecondaryAction>
                                                                                <IconButton>
                                                                                    <Icon name="right-arrow" size={24} color="#e91e60" />
                                                                                </IconButton>
                                                                            </ListItemSecondaryAction>
                                                                    </ListItem>}
                                                                    <Divider variant="middle" component="li" />
                                                                    <ListItem button onClick={() => this.showPinPuk()}>
                                                                        <ListItemText
                                                                            primary={t('selfcare:item.pinpuk')}
                                                                        />
                                                                        <ListItemSecondaryAction>
                                                                            <IconButton>
                                                                                <Icon name="right-arrow" size={24} color="#e91e60" />
                                                                            </IconButton>
                                                                        </ListItemSecondaryAction>
                                                                    </ListItem>
                                                                    <Divider variant="middle" component="li" />
                                                                </List>
                                                            </div>)}
                                                            <div style={{ padding: '10px' }}>
                                                                <table>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td>
                                                                                <div style={{ fontSize: '1.3125rem', paddingBottom: '5px' }}>
                                                                                    {t('selfcare:info.needhelp')}
                                                                            </div>
                                                                                <div>
                                                                                    <span dangerouslySetInnerHTML={{ __html: t('selfcare:info.contact') }} />
                                                                            </div>
                                                                            </td>
                                                                            <td>
                                                                                <Icon name="help" size={64} color="#e91e60" />
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </GridItem>
                                                    </GridContainer>
                                                </div>
                                            {/*</Slide>*/}
                                        </GridItem>
                                    </GridContainer>
                                </GridItem>
                            </GridContainer>
                        </div>
                        <div>
                            <div>
                                {this.state.Subscription && this.state.Subscription.User && <OverviewSubscription updateHeight={this.UpdateSwipeableViewHeight} isAdministrating={this.state.IsAdministrating} show={this.state.show} parent={this} subscription={this.state.Subscription} IsSweden={this.state.IsSweden} IsNorway={this.state.IsNorway} />}
                            </div>
                        </div>
                        <div>
                            <div>
                                {this.state.Subscription && this.state.Subscription.User && <OverviewOtherSubscriptions updateHeight={this.UpdateSwipeableViewHeight} changeSetting={this.changeSetting} administratedMsisdn={this.state.AdministratedMsisdn} changeAdmin={this.changeAdmin} adminNumber={this.administrateNumber} show={this.state.show} parent={this} isAdmin={this.state.IsAdmin} customer={this.state.Customer} otherSubscriptions={this.state.OtherSubscriptions} />}
                            </div>
                        </div>
                    </SwipeableViews>
                    <div style={{ height: paddingBottom }} />
                </div>
                <Hidden smDown>
                    <Drawer open={this.state.DrawerOpen} onClose={this.toggleDrawer(false)}>
                        <div
                            tabIndex={0}
                            role="button"
                            onClick={this.toggleDrawer(false)}
                            onKeyDown={this.toggleDrawer(false)}
                            style={{ paddingTop: '64px' }}
                        >
                            {sideList}
                        </div>
                    </Drawer>
                </Hidden>
                <Hidden mdUp>
                    <Drawer anchor="right" open={this.state.DrawerOpen} onClose={this.toggleDrawer(false)}>
                        <div
                            tabIndex={0}
                            role="button"
                            onClick={this.toggleDrawer(false)}
                            onKeyDown={this.toggleDrawer(false)}
                            style={{ paddingBottom: '64px' }}
                        >
                            {sideList}
                        </div>
                    </Drawer>
                </Hidden>
                <Hidden mdUp>
                    <BottomNavigation style={stickToBottom}
                        value={this.state.navigationValue}
                        onChange={this.handleNavigationChange}
                        className={classes.root}
                        showLabels={true}
                    >
                        <BottomNavigationAction classes={{ root: classes.root, selected: classes.selected, label: classes.label }} label={t('selfcare:tab.overview')} icon={<Icon name="usage" size={24} color="currentColor" />} />
                        <BottomNavigationAction classes={{ root: classes.root, selected: classes.selected, label: classes.label }} label={this.state.IsSweden ? t('selfcare:label.my-subscription-swe') : t('selfcare:label.my-subscription', { 0: `${this.state.Subscription ? this.state.Subscription.Type : t('selfcare:phrase.subscriptionlc')}` })} icon={<Icon name="settings" size={24} color="currentColor" />} />
                        <BottomNavigationAction classes={{ root: classes.root, selected: classes.selected, label: classes.label }} label={`${this.state.Customer && this.state.Customer.TypeNo === "20" ? t('selfcare:tab.othersubscriptioncompany') : t('selfcare:tab.othersubscriptionfamily')}`} icon={<Icon name="family" size={24} color="currentColor" />} />
                        <BottomNavigationAction classes={{ root: classes.root }} icon={<MenuIcon />} />
                    </BottomNavigation>
                </Hidden>
            </div >
        );
    }
}

Overview.propTypes = {
    classes: PropTypes.object.isRequired,
    onAuthenticated: PropTypes.func
};

export default compose(
    withStyles(styles),
    withWidth(),
    withTranslation(),
)(withSnackbar(withAITracking(reactPlugin, Overview)));
